export const SUPPORT_URL = 'https://supportcenter.checkpoint.com/';
export const SUPPORT_CYBERINT_EXTENSION_URL = 'https://cyberint.com/check-point-intelligence-chrome-extension/#faq';
export const CONTACT_US_THREAT_HUNTING = 'https://l.cyberint.com/contact-us-threat-hunting';
